import { Action, createReducer } from '@ngrx/store';
import { ToastState } from './toast.state';

const initialState = new ToastState();

const reducer = createReducer(initialState);

export function toastReducer(state: ToastState | null, action: Action) {
  return reducer(state, action);
}
